//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Stars from '../Stars';

export default {
  props: {
    hotelInfo: {
      type: Object,
      default: {},
    },
    evaluationData: Array,
  },
  name: 'evaluation',
  components: {Stars},
}



// WEBPACK FOOTER //
// ./src/components/Evaluation/Evaluation.vue